/**
 * TN Trustpilot reviews slider
 * Slides reviewkaarten (kind-blokken). Kaartbreedte komt uit CSS (responsief),
 * JS verzorgt de transform-offset, pijlen, autoplay en herberekening bij resize.
 * Gebaseerd op "Trustpilot Review Slider.dc.html".
 */
class TnTpSlider extends HTMLElement {
  connectedCallback() {
    if (this._init) return;
    this._init = true;

    this.track = this.querySelector('[data-tptp-track]');
    this.viewport = this.querySelector('[data-tptp-viewport]');
    this.cards = [...this.querySelectorAll('[data-tptp-card]')];
    this.prevBtn = this.querySelector('[data-tptp-prev]');
    this.nextBtn = this.querySelector('[data-tptp-next]');

    if (!this.track || !this.cards.length) return;

    this.gap = parseInt(this.dataset.gap, 10) || 16;
    this.cardsDesktop = parseInt(this.dataset.cardsDesktop, 10) || 3;
    this.cardsMobile = parseInt(this.dataset.cardsMobile, 10) || 1;
    this.showArrows = this.dataset.showArrows === 'true';
    this.autoplay = this.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 3800;
    this.startIndex = 0;
    this.mq = window.matchMedia('(max-width: 749px)');

    this.bind();
    this.layout();

    if (window.ResizeObserver) {
      this.ro = new ResizeObserver(() => this.layout());
      this.ro.observe(this.viewport);
    } else {
      this._onResize = () => this.layout();
      window.addEventListener('resize', this._onResize);
    }

    this.maybeAutoplay();
  }

  disconnectedCallback() {
    if (this.ro && this.viewport) this.ro.unobserve(this.viewport);
    if (this._onResize) window.removeEventListener('resize', this._onResize);
    this.stopAuto();
  }

  n() { return this.mq.matches ? this.cardsMobile : this.cardsDesktop; }
  maxStart() { return Math.max(0, this.cards.length - this.n()); }

  bind() {
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(-1));
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(1));
    this.addEventListener('mouseenter', () => this.stopAuto());
    this.addEventListener('mouseleave', () => this.maybeAutoplay());
    this.addEventListener('focusin', () => this.stopAuto());
    this.addEventListener('focusout', () => this.maybeAutoplay());
  }

  go(dir) {
    const ms = this.maxStart();
    this.startIndex = Math.min(ms, Math.max(0, this.startIndex + dir));
    this.update();
    // herstart de autoplay-timer na handmatige navigatie
    if (this._timer) this.maybeAutoplay();
  }

  maybeAutoplay() {
    this.stopAuto();
    if (this.autoplay && this.cards.length > this.n()) {
      this._timer = setInterval(() => {
        this.startIndex = this.startIndex >= this.maxStart() ? 0 : this.startIndex + 1;
        this.update();
      }, this.autoplaySpeed);
    }
  }

  stopAuto() { if (this._timer) { clearInterval(this._timer); this._timer = null; } }

  layout() {
    this.startIndex = Math.min(this.startIndex, this.maxStart());
    this.update();
  }

  update() {
    const card = this.cards[0];
    const cardW = card ? card.getBoundingClientRect().width : 0;
    const step = cardW + this.gap;
    this.track.style.transform = 'translateX(' + (-this.startIndex * step) + 'px)';

    const hideArrows = !this.showArrows || this.cards.length <= this.n();
    [this.prevBtn, this.nextBtn].forEach((b) => { if (b) b.style.display = hideArrows ? 'none' : ''; });
    if (this.prevBtn) this.prevBtn.disabled = this.startIndex <= 0;
    if (this.nextBtn) this.nextBtn.disabled = this.startIndex >= this.maxStart();
  }
}

if (!customElements.get('tn-tp-slider')) {
  customElements.define('tn-tp-slider', TnTpSlider);
}
